<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="24">
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <!--<div class="table-operator">-->
      <!--<a-button type="primary" icon="download" @click="downloadCxb">产险报表下载</a-button>-->
      <!--<a-button type="primary" icon="download">-->
        <!--<a :href="`${path}jarsx.xls`" style="color:white;" download="九安保险经纪人身险报表.xls">人身险报表下载</a>-->
      <!--</a-button>-->
      <!--<a-button type="primary" icon="download" @click="downloadHzb">汇总报表下载</a-button>-->
      <!--<a-button type="primary" icon="download" @click="downloadLrb">利润报表下载</a-button>-->
    <!--</div>-->

    <div style="margin-top: 30px;width: 800px; font-size:24px;color:#fff;">
      <div style="height: 200px;border-bottom: 1px solid #ccc;">
        <div style="float:left; width: 50%;height: 200px; border-right: 1px solid #ccc;">
          <div style="cursor:pointer; height: 60%;width: 60%; margin:15% 0 0 30%;background-color: rgba(24,144,255,0.75); text-align: center;padding-top:40px;" @click="downloadCxb">
            产险报表下载
          </div>
        </div>
        <div style="float:left; width: 49%;height: 200px;">
          <div style="cursor:pointer; height: 60%;width: 60%; margin:15% 0 0 10%;background-color: rgba(24,144,255,0.75); text-align: center;padding-top:40px;" @click="downloadRsx">
            人身险报表下载
          </div>
          <a id="rsxbb" :href="`${path}jarsx.xls`" style="width:0;height:0;color:#fff;" download="九安保险经纪人身险报表.xls"></a>
        </div>
      </div>
      <div style="height: 200px;">
        <div style="float:left; width: 50%;height: 200px; border-right: 1px solid #ccc;">
          <div style="cursor:pointer; height: 60%;width: 60%; margin:5% 0 0 30%;background-color: rgba(24,144,255,0.75); text-align: center;padding-top:40px;" @click="downloadLrb">
            利润报表下载
          </div>
        </div>
        <div style="float:left; width: 49%;height: 200px;">
          <div style="cursor:pointer; height: 60%;width: 60%; margin:5% 0 0 10%;background-color: rgba(24,144,255,0.75); text-align: center;padding-top:40px;" @click="downloadHzb">
            汇总报表下载
          </div>
        </div>
      </div>
    </div>
    <!-- table区域-begin -->
    <div>
      <div style="margin-bottom: 16px;">
      </div>
    </div>
  </a-card>
</template>

<script>
  import {JeecgListMixin} from '@/mixins/JeecgListMixin'
  import ARow from 'ant-design-vue/es/grid/Row'
  import ACol from 'ant-design-vue/es/grid/Col'
  export default {
    name: 'CircReportForm',
    mixins: [JeecgListMixin],
    components: {
      ACol,
      ARow
    },
    data () {
      return {
        disableMixinCreated: true, //禁止初始查询
        path: process.env.BASE_URL,
        description: '监管报表下载页面',
        queryParam:{
          insurerNumber:'',
          phase:''
        },
        // 表头
        columns: [],
        url: {
          cxbDownload: "/bms/bizBusinessinfo/exportProductXls", //产险下载
          hzbDownload: "/bms/bizBusinessinfo/exportTotalXls", // 汇总报表下载
          lrbDownload: "/bms/bizBusinessinfo/exportProfitXls", // 利润报表下载
        },
      }
    },
    created() {
      console.log(this.path)
    },
    computed: {
      cxbDownloadUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.cxbDownload}`;
      },
    },
    methods: {
      initDictConfig(){
      },
      // 产险表下载
      downloadCxb(){
        //调用公共方法
        this.handleExportXlsByUrl(this.url.cxbDownload,"产险报表",{});
      },
      downloadHzb(){
        this.handleExportXlsByUrl(this.url.hzbDownload,"汇总报表",{});
      },
      downloadLrb(){
        this.handleExportXlsByUrl(this.url.lrbDownload,"利润报表",{});
      },
      downloadRsx(){
        document.getElementById("rsxbb").click();
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>